var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.12 12.5775V5.49461C29.12 5.20245 28.7667 5.05621 28.56 5.26261L15.7037 18.1193C14.5558 19.2671 14.5558 21.1276 15.7037 22.2754L24.0361 30.6079C24.2429 30.8146 24.5961 30.6681 24.5961 30.3759V23.293C24.5961 23.0031 24.4809 22.725 24.2758 22.5199L21.9533 20.1973L28.8 13.3506C29.0048 13.1455 29.12 12.8674 29.12 12.5775Z",
    fill: "#92C174"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2965 9.70234L7.96404 1.37018C7.75732 1.16346 7.40404 1.31002 7.40404 1.60218V8.68506C7.40404 8.97498 7.51924 9.25306 7.72436 9.45818L10.0469 11.7807L3.2002 18.6271C2.99508 18.8323 2.87988 19.1103 2.87988 19.4003V26.4831C2.87988 26.7753 3.23316 26.9215 3.43988 26.7151L16.2965 13.8585C17.444 12.7107 17.444 10.8502 16.2965 9.70234Z",
    fill: "#C6FCA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2fde0fe111953c5c69899df866abc9e1.svg";
export { ForwardRef as ReactComponent };